export default __webpack_public_path__ + "static/media/bell-icon.08077956.svg";